module.exports = __webpack_public_path__ + "static/media/W5390484_13.6737b8ed.jpg";